import { HttpContextToken } from '@angular/common/http';

/** Set on requests that must not trigger 401 → refresh (e.g. refresh endpoint itself). */
export const SKIP_AUTH_REFRESH = new HttpContextToken<boolean>(() => false);
